/** The login page, as the place a signed-out user goes. It keeps the page, and after an ended session it says so. */
export function loginPathFor(location: { pathname: string; search: string }, sessionEnded: boolean): string {
  const params = new URLSearchParams();
  if (sessionEnded) params.set('reason', 'session_ended');
  const current = `${location.pathname}${location.search}`;
  if (current !== '/') params.set('return_to', current);
  const query = params.toString();
  return query ? `/login?${query}` : '/login';
}
